import React from 'react';
import styles from './PermissionsSettings.module.scss';
import ButtonsBarLookup from '../../../Components/ButtonsBarLookup';
import Messages from '../../../Components/Messages';
import Http from '../../../Api/http';
import ProgressSpinner from '../../../Components/ProgressSpinner';
import Util from '../../../Util';
import Card from '../../../Components/Card';
import Checkbox from '../../../Components/Checkbox';
import Spinner from '../../../Components/Spinner';
import AlertBox from '../../../Components/AlertBox';

const $ = window.$;

export default class PermissionsSettings extends React.Component {
  constructor(props) {
    super(props);
    this.hash = null;
    this.doHotKeys = true;
    this.state = {
      loading: true,
      mode: 'new',
      pageInfo: this.setPageInfo(),
      formErrors: {},
      deleteErrors: { deleteNote: '' },
      fromArchive: false,
      isDesktop: window.innerWidth > 800,
      dataObject: {
        id: 0,
        allowUserConcurrentLogin: false,
        PasswordExpires: false,
        passwordExpireDays: 0,
        allowRetryForLockedUser: false,
        wrongPasswordCount: 0,
        lockedUserRetryMinutes: 0,
        isComplexPassword: false,
        minPassLength: 10,
      },
    };
  }

  updatePredicate = () => {
    this.setState({ isDesktop: window.innerWidth > 800 });
  };

  componentDidMount = async () => {
    if (!Util.checkIsSuperAdmin()) {
      Util.goTo('/Access');
    }
    this.setState({ dataObject: { ...this.state.dataObject }, loading: false });
    let obj = await this.getData(this.props.match.params.id);
    this.loadData(obj, false);

    document.addEventListener('keydown', this.onPageKeyDown);
    document.addEventListener('resize', this.updatePredicate);
  };

  onPageKeyDown = async (e) => {
    if (!this.doHotKeys) return;
    this.doHotKeys = false;
    switch (e.keyCode) {
      case Util.keyboardKeys.F3: {
        e.preventDefault();
        if (!this.state.fromArchive) {
          await this.onSave(e, false);
        }
        break;
      }
      default: {
      }
    }
    this.doHotKeys = true;
  };


  handleUserInput = (e) => {
    const name = e.target.id;
    const value = e.target ? e.target.value : e.value;

    this.setState({ dataObject: { ...this.state.dataObject, [name]: value } });
  };

  validateField() {
    let fieldValidationErrors = this.state.formErrors;
    let result = true;

    fieldValidationErrors.minPassLength = '';
    if (!this.state.dataObject.minPassLength || this.state.dataObject.minPassLength <= 0) {
      result = false;
      fieldValidationErrors.minPassLength = $.strings.requiredFiled + ' ' + $.strings.PermissionsSettings.greaterThanZero;
    }
    fieldValidationErrors.wrongPasswordCount = '';
    if (!this.state.dataObject.wrongPasswordCount || this.state.dataObject.wrongPasswordCount <= 0) {
      result = false;
      fieldValidationErrors.wrongPasswordCount = $.strings.requiredFiled + ' ' + $.strings.PermissionsSettings.greaterThanZero;
    }

    if (this.state.dataObject.allowRetryForLockedUser) {
      fieldValidationErrors.lockedUserRetryMinutes = '';
      if (!this.state.dataObject.lockedUserRetryMinutes || this.state.dataObject.lockedUserRetryMinutes <= 0) {
        result = false;
        fieldValidationErrors.lockedUserRetryMinutes = $.strings.requiredFiled + ' ' + $.strings.PermissionsSettings.greaterThanZero;
      }
    }
    fieldValidationErrors.passwordExpireDays = '';
    if (!this.state.dataObject.passwordExpireDays || this.state.dataObject.passwordExpireDays <= 0) {
      result = false;
      fieldValidationErrors.passwordExpireDays = $.strings.requiredFiled + ' ' + $.strings.PermissionsSettings.greaterThanZero;
    }

    if (!result) {
      this.setState({ formErrors: fieldValidationErrors });
    }

    return result;
  }

  render() {
    let screenHeader = (
      <div className={`${'p-grid'} ${styles.titleBar}`}>
        <div className="p-col-12 p-lg-12 p-sm-12" style={{ verticalAlign: 'middle' }}>
          <h2 className={styles.title}>{this.state.pageInfo.title}</h2>
        </div>
      </div>
    );
    const buttonsList = [
      {
        label: $.strings.PermissionsSettings.ApplaySettingsToAllUsers,
        tooltip: $.strings.PermissionsSettings.ApplaySettingsToAllUsersToolTip,
        command: this.onApplaySettingsClick,
        visible: true,
      },
    ];
    return (
      <div ref="divMain" className={styles.AddBanks}>
        <ProgressSpinner loading={this.state.loading} />
        {screenHeader}

        {this.state.saveBoxVisible && <AlertBox ref={(e) => (this.saveBox = e)} header={$.strings.appName} defaultButton={Util.defaultButton.No} />}

        <Card>
          <div className="p-grid">
            <div className="p-col-12 p-xl-12 p-lg-12 p-md-12 p-sm-12">
              {/* <ButtonsBarLookup
               // itemsList={buttonsList}
                onSaveWithoutClose={(e) => this.onSave(e, true)}
               // onLogFile={(e) => this.onLogFile(e, true)}
               // onResetArchive={this.state.fromArchive ? this.onResetArchive : undefined}
                pageId={this.state.pageInfo.pageId}
                parent={this}
              /> */}

<ButtonsBarLookup
                onSave={(e) => this.onSave(e, false)}
                //onPrevious={(e) => this.onPrevious(e, true)}
                //onNext={(e) => this.onNext(e, true)}
               // onRefresh={(e) => this.onRefresh(e, true)}
                //onPrint={(e) => this.onPrint(e, true)}
               // onExcelExport={(e) => this.onExcelExport()}
                pageId={this.state.pageInfo.pageId}
                onClone = {(e) => this.onClone(e)}
                parent={this}
              />
            </div>
          </div>
          <Messages innerRef={(el) => (this.messages = el)} />
        </Card>

        <div className="p-grid">
          {/*Right Side*/}
          <div className="p-col-12 p-xl-12 p-lg-12 p-md-12 p-sm-12">
            <Card>
              {/*كلمة المرور معقدة*/}
              <div className="p-grid">
                <div className="p-col-12 p-xl-6 p-lg-8 p-md-12 p-sm-12">
                  <Checkbox
                    caption={$.strings.PermissionsSettings.complexPassword}
                    id="isComplexPassword"
                    inputId="isComplexPassword"
                    checked={this.state.dataObject.isComplexPassword}
                    tooltip={$.strings.PermissionsSettings.complexPasswordTooltip}
                    onChange={(e) => this.setState({ dataObject: { ...this.state.dataObject, isComplexPassword: e.checked } })}
                  />
                </div>
              </div>
              {/*الحد الادنى لطول كلمة المرور*/}
              <div className="p-grid">
                <div className="p-col-12 p-xl-6 p-lg-8 p-md-12 p-sm-12">
                  <Spinner
                    id="minPassLength"
                    value={this.state.dataObject.minPassLength}
                    caption={$.strings.PermissionsSettings.minPassLength}
                    onChange={(e) => this.setState({ dataObject: { ...this.state.dataObject, minPassLength: e.value } })}
                    style={{ width: '100%' }}
                    isRequired={true}
                    formErrors={this.state.formErrors}
                    min={0}
                    max={50}
                  />
                </div>
              </div>
              {/*عدد مرات محاولة الدخول الخاطىء */}
              <div className="p-grid">
                <div className="p-col-12 p-xl-6 p-lg-8 p-md-12 p-sm-12">
                  <Spinner
                    id="wrongPasswordCount"
                    value={this.state.dataObject.wrongPasswordCount}
                    caption={$.strings.PermissionsSettings.wrongPasswordCount}
                    onChange={(e) => this.setState({ dataObject: { ...this.state.dataObject, wrongPasswordCount: e.value } })}
                    style={{ width: '100%' }}
                    isRequired={true}
                    formErrors={this.state.formErrors}
                    min={0}
                    max={1000}
                  />
                </div>
              </div>
              <div className="p-grid">
                {/* مدة معاودة الدخول الخاطيء بالدقائق */}
                <div className="p-col-12 p-xl-6 p-lg-8 p-md-12 p-sm-12">
                  <Spinner
                    id="lockedUserRetryMinutes"
                    value={this.state.dataObject.lockedUserRetryMinutes}
                    caption={$.strings.PermissionsSettings.lockedUserRetryMinutes}
                    onChange={(e) => this.setState({ dataObject: { ...this.state.dataObject, lockedUserRetryMinutes: e.value } })}
                    style={{ width: '100%' }}
                    isRequired={true}
                    formErrors={this.state.formErrors}
                    min={0}
                    max={1000}
                  />
                </div>
                {/* السماح بمعاودة الدخول بعد عدد المحاولات الخاطئة*/}
                <div className="p-col-12 p-xl-6 p-lg-8 p-md-12 p-sm-12" style={{ alignSelf: 'flex-end' }}>
                  <Checkbox
                    caption={$.strings.PermissionsSettings.allowRetryForLockedUser}
                    id="allowRetryForLockedUser"
                    inputId="allowRetryForLockedUser"
                    checked={this.state.dataObject.allowRetryForLockedUser}
                    onChange={(e) => this.setState({ dataObject: { ...this.state.dataObject, allowRetryForLockedUser: e.checked } })}
                  />
                </div>
              </div>
              <div className="p-grid">
                {/* عدد ايام انتهاء كلمة المرور */}
                <div className="p-col-12 p-xl-6 p-lg-6 p-md-12 p-sm-12">
                  <Spinner
                    id="passwordExpireDays"
                    value={this.state.dataObject.passwordExpireDays}
                    caption={$.strings.PermissionsSettings.passwordExpireDays}
                    onChange={(e) => this.setState({ dataObject: { ...this.state.dataObject, passwordExpireDays: e.value } })}
                    style={{ width: '100%' }}
                    isRequired={true}
                    formErrors={this.state.formErrors}
                    min={0}
                    max={1000}
                  />
                </div>
                {/* كلمة المرور لها فترة انتهاء*/}
                <div className="p-col-12 p-xl-6 p-lg-6 p-md-12 p-sm-12" style={{ alignSelf: 'flex-end' }}>
                  <Checkbox
                    caption={$.strings.PermissionsSettings.PasswordExpires}
                    id="PasswordExpires"
                    inputId="PasswordExpires"
                    checked={this.state.dataObject.PasswordExpires}
                    onChange={(e) => this.setState({ dataObject: { ...this.state.dataObject, PasswordExpires: e.checked } })}
                  />
                </div>
              </div>
              <div className="p-grid">
                {/* السماح بتعدد الدخول للمستخدم */}
                <div className="p-col-12 p-xl-6 p-lg-8 p-md-12 p-sm-12" style={{ alignSelf: 'flex-end' }}>
                  <Checkbox
                    caption={$.strings.PermissionsSettings.allowUserConcurrentLogin}
                    id="allowUserConcurrentLogin"
                    inputId="allowUserConcurrentLogin"
                    checked={this.state.dataObject.allowUserConcurrentLogin}
                    onChange={(e) => this.setState({ dataObject: { ...this.state.dataObject, allowUserConcurrentLogin: e.checked } })}
                  />
                </div>
              </div>
            </Card>
          </div>
        </div>
      </div>
    );
  }

  onResetArchive = async () => {
    let obj = await this.getData(this.props.match.params.id);
    this.loadData(obj, false);
  };

  onApplaySettingsClick = async () => {
    if (!this.validateField()) {
      console.log(11);
      return;
    }
    this.setState({ loading: true });
    let result = await this.saveData(true);
    if (result.status === 200) {
      Util.showSuccessMsg(this.messages);
    } else if (result.status === 400) {
      Util.showErrorMsg(this.messages, result.message.message);
    } else {
      Util.showErrorMsg(this.messages);
    }
    this.setState({ loading: false });
  };
  onSave = async (e,applayAllUser) => {
    if (!this.validateField()) {
      return;
    }
    this.setState({ loading: true });
    //console.log(this.state.dataObject)
    let result = await this.saveData(applayAllUser);
    if (result.status === 200 && result.data ===true) {
      Util.showSuccessMsg(this.messages);
    } else if (result.status === 400) {
      Util.showErrorMsg(this.messages, result.message.message);
    } else {
      Util.showErrorMsg(this.messages);
    }
    this.setState({ loading: false });
  };
  saveData = async (applayAllUser) => {
    let obj = {
      id: this.state.dataObject.id,
      isComplexPassword: this.state.dataObject.isComplexPassword,
      minPassLength: this.state.dataObject.minPassLength,
      wrongPasswordCount: this.state.dataObject.wrongPasswordCount,
      allowRetryForLockedUser: this.state.dataObject.allowRetryForLockedUser,
      lockedUserRetryMinutes: this.state.dataObject.lockedUserRetryMinutes,
      PasswordExpires: this.state.dataObject.PasswordExpires,
      passwordExpireDays: this.state.dataObject.passwordExpireDays,
      allowUserConcurrentLogin: this.state.dataObject.allowUserConcurrentLogin,
      page_id: this.state.pageInfo.pageId,
      applayToAllUsers: applayAllUser,
    };

    let saveResult;
    let res = await Http.postMultipartAxios(Http.actions.PermissionsSettings.urlSavePermissionsSettings, obj, this.state.pageInfo.pageId);
    saveResult = res;

    return saveResult;
  };

  getData = async () => {
    let dataTemp = [];
    const params = {
    };

    let res = await Http.getJsonAxios(Http.actions.PermissionsSettings.urlGetPermissionsSettings, params, this.state.pageInfo.pageId);
    if (res.status === 200) {
      dataTemp = res.data.list;
    }
    return dataTemp;
  };

  loadData = (rowData, loadFromArchive) => {
    let obj = rowData;
    if (rowData && Array.isArray(rowData) && rowData.length > 0) obj = rowData[0];
    console.log(obj)
    this.setState(
      {
        dataObject: {
          ...this.state.dataObject,
          id: obj.id,
          allowUserConcurrentLogin: obj.allowUserConcurrentLogin,
          PasswordExpires: obj.PasswordExpires,
          passwordExpireDays: obj.passwordExpireDays,
          allowRetryForLockedUser: obj.allowRetryForLockedUser,
          wrongPasswordCount: obj.wrongPasswordCount,
          lockedUserRetryMinutes: obj.lockedUserRetryMinutes,
          isComplexPassword: obj.isComplexPassword,
          minPassLength: obj.minPassLength,
        },
        mode: 'edit',
        loading: false,
      },
    
    );
  };

  popupHasCalled = () => {
    document.removeEventListener('keydown', this.onPageKeyDown);
  };
  popupHasClosed = () => {
    document.addEventListener('keydown', this.onPageKeyDown);
  };

  onLogFile = (e, checkChanging) => {
    if (!Util.checkUserAccess(9)) {
      return;
    }
    if (!this.state.fromArchive && checkChanging ) {
      this.popupHasCalled();
      this.setState({ saveBoxVisible: true }, () => {
        this.saveBox.show(
          async () => {
            let res = await this.onSaveWithoutClose(e, false);
            this.popupHasClosed();
            this.setState({ saveBoxVisible: false });
            return res;
          },
          () => {
            this.onLogFile(e, false);
            this.popupHasClosed();
            this.setState({ saveBoxVisible: false });
          },
          () => {
            this.setState({ saveBoxVisible: false });
            this.popupHasClosed();
          },
          $.strings.dataChanged
        );
      });
      return;
    }
    if (this.state.dataObject.id) {
      //this.logFileDialog.showDialog(this.state.pageInfo.pageId, this.state.dataObject.id)
      this.popupHasCalled();
      this.setState({ logFileDialogVisible: true });
    } else Util.showInfoMsg(this.messages, $.strings.selectRecord);
  };
  showFromLog = (obj) => {
    if (obj) {
      this.loadData(obj, true);
    }
  };
  logFileDialogClose = () => {
    this.popupHasClosed();
    this.setState({ logFileDialogVisible: false });
  };

  onAddSuccess = (result) => {
    if (result) {
      this.setState({ dlgAddVisible: false });
      this.getData(false);
    }
  };

  setPageInfo = () => {
    let pageId = 0;
    let title = $.strings.PermissionsSettings.title;
    return { pageId: pageId, title: title };
  };
  onClone =(e) =>
  {
   this.onSave(e,true);
  }
}
